import {c as createCommonjsModule} from "./common/_commonjsHelpers-4f955397.js";
var jsonConvertEnums = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  (function(OperationMode) {
    OperationMode[OperationMode["DISABLE"] = 0] = "DISABLE";
    OperationMode[OperationMode["ENABLE"] = 1] = "ENABLE";
    OperationMode[OperationMode["LOGGING"] = 2] = "LOGGING";
  })(exports.OperationMode || (exports.OperationMode = {}));
  (function(PropertyMatchingRule) {
    PropertyMatchingRule[PropertyMatchingRule["CASE_STRICT"] = 1] = "CASE_STRICT";
    PropertyMatchingRule[PropertyMatchingRule["CASE_INSENSITIVE"] = 2] = "CASE_INSENSITIVE";
  })(exports.PropertyMatchingRule || (exports.PropertyMatchingRule = {}));
  (function(ValueCheckingMode) {
    ValueCheckingMode[ValueCheckingMode["ALLOW_NULL"] = 1] = "ALLOW_NULL";
    ValueCheckingMode[ValueCheckingMode["ALLOW_OBJECT_NULL"] = 2] = "ALLOW_OBJECT_NULL";
    ValueCheckingMode[ValueCheckingMode["DISALLOW_NULL"] = 3] = "DISALLOW_NULL";
  })(exports.ValueCheckingMode || (exports.ValueCheckingMode = {}));
});
var jsonConvertOptions = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var Settings = function() {
    function Settings2() {
    }
    Settings2.MAPPING_PROPERTY = "__jsonconvert__mapping__";
    Settings2.MAPPER_PROPERTY = "__jsonconvert__mapper__";
    Settings2.CLASS_IDENTIFIER = "__jsonconvert__class_identifier__";
    return Settings2;
  }();
  exports.Settings = Settings;
  var MappingOptions = function() {
    function MappingOptions2() {
      this.classPropertyName = "";
      this.jsonPropertyName = "";
      this.expectedJsonType = void 0;
      this.isOptional = false;
      this.customConverter = null;
    }
    return MappingOptions2;
  }();
  exports.MappingOptions = MappingOptions;
});
var any = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var Any = function() {
    function Any2() {
    }
    return Any2;
  }();
  exports.Any = Any;
});
var jsonConvert = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var JsonConvert2 = function() {
    function JsonConvert3(operationMode, valueCheckingMode, ignorePrimitiveChecks, propertyMatchingRule) {
      this._operationMode = jsonConvertEnums.OperationMode.ENABLE;
      this._valueCheckingMode = jsonConvertEnums.ValueCheckingMode.ALLOW_OBJECT_NULL;
      this._ignorePrimitiveChecks = false;
      this._propertyMatchingRule = jsonConvertEnums.PropertyMatchingRule.CASE_STRICT;
      this._ignoreRequiredCheck = false;
      if (operationMode !== void 0 && operationMode in jsonConvertEnums.OperationMode)
        this.operationMode = operationMode;
      if (valueCheckingMode !== void 0 && valueCheckingMode in jsonConvertEnums.ValueCheckingMode)
        this.valueCheckingMode = valueCheckingMode;
      if (ignorePrimitiveChecks !== void 0)
        this.ignorePrimitiveChecks = ignorePrimitiveChecks;
      if (propertyMatchingRule !== void 0)
        this.propertyMatchingRule = propertyMatchingRule;
    }
    Object.defineProperty(JsonConvert3.prototype, "operationMode", {
      get: function() {
        return this._operationMode;
      },
      set: function(value) {
        if (value in jsonConvertEnums.OperationMode)
          this._operationMode = value;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(JsonConvert3.prototype, "valueCheckingMode", {
      get: function() {
        return this._valueCheckingMode;
      },
      set: function(value) {
        if (value in jsonConvertEnums.ValueCheckingMode)
          this._valueCheckingMode = value;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(JsonConvert3.prototype, "ignorePrimitiveChecks", {
      get: function() {
        return this._ignorePrimitiveChecks;
      },
      set: function(value) {
        this._ignorePrimitiveChecks = value;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(JsonConvert3.prototype, "propertyMatchingRule", {
      get: function() {
        return this._propertyMatchingRule;
      },
      set: function(value) {
        if (value in jsonConvertEnums.PropertyMatchingRule)
          this._propertyMatchingRule = value;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(JsonConvert3.prototype, "ignoreRequiredCheck", {
      get: function() {
        return this._ignoreRequiredCheck;
      },
      set: function(value) {
        this._ignoreRequiredCheck = value;
      },
      enumerable: true,
      configurable: true
    });
    JsonConvert3.prototype.serialize = function(data, classReference) {
      if (this.operationMode === jsonConvertEnums.OperationMode.DISABLE) {
        return data;
      }
      if (data instanceof Array) {
        return this.serializeArray(data, classReference);
      } else if (typeof data === "object") {
        return this.serializeObject(data, classReference);
      } else {
        throw new Error("Fatal error in JsonConvert. Passed parameter data in JsonConvert.serialize() is not in valid format (object or array).\n");
      }
    };
    JsonConvert3.prototype.serializeObject = function(data, classReference) {
      if (this.operationMode === jsonConvertEnums.OperationMode.DISABLE) {
        return data;
      }
      if (data === void 0) {
        throw new Error("Fatal error in JsonConvert. Passed parameter instance in JsonConvert.serializeObject() is undefined. This is not a valid JSON format.\n");
      } else if (data === null) {
        if (this.valueCheckingMode === jsonConvertEnums.ValueCheckingMode.DISALLOW_NULL) {
          throw new Error("Fatal error in JsonConvert. Passed parameter instance in JsonConvert.serializeObject() is undefined. You have specified to disallow null values.\n");
        } else {
          return data;
        }
      } else if (typeof data !== "object" || data instanceof Array) {
        throw new Error("Fatal error in JsonConvert. Passed parameter instance in JsonConvert.serializeObject() is not of type object.\n");
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
        console.log("----------");
        console.log("Receiving JavaScript instance:");
        console.log(data);
      }
      var jsonObject = {};
      var instance;
      if (!!classReference) {
        instance = new classReference();
      } else {
        instance = data;
      }
      for (var _i = 0, _a = Object.keys(instance); _i < _a.length; _i++) {
        var propertyKey = _a[_i];
        try {
          this.serializeObject_loopProperty(data, instance, propertyKey, jsonObject);
        } catch (ex) {
          if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
            console.log("Failed to serialize property:");
            console.log(ex);
            console.log("----------");
          }
          throw ex;
        }
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
        console.log("Returning JSON object:");
        console.log(jsonObject);
        console.log("----------");
      }
      return jsonObject;
    };
    JsonConvert3.prototype.serializeArray = function(dataArray, classReference) {
      if (this.operationMode === jsonConvertEnums.OperationMode.DISABLE) {
        return dataArray;
      }
      if (dataArray === void 0) {
        throw new Error("Fatal error in JsonConvert. Passed parameter instanceArray in JsonConvert.serializeArray() is undefined. This is not a valid JSON format.\n");
      } else if (dataArray === null) {
        if (this.valueCheckingMode === jsonConvertEnums.ValueCheckingMode.DISALLOW_NULL) {
          throw new Error("Fatal error in JsonConvert. Passed parameter instanceArray in JsonConvert.serializeArray() is undefined. You have specified to disallow null values.\n");
        } else {
          return dataArray;
        }
      } else if (typeof dataArray !== "object" || dataArray instanceof Array === false) {
        throw new Error("Fatal error in JsonConvert. Passed parameter instanceArray in JsonConvert.serializeArray() is not of type array.\n");
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
        console.log("----------");
        console.log("Receiving JavaScript array:");
        console.log(dataArray);
      }
      var jsonArray = [];
      for (var _i = 0, _a = dataArray; _i < _a.length; _i++) {
        var dataObject = _a[_i];
        jsonArray.push(this.serializeObject(dataObject, classReference));
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
        console.log("Returning JSON array:");
        console.log(jsonArray);
        console.log("----------");
      }
      return jsonArray;
    };
    JsonConvert3.prototype.deserialize = function(json, classReference) {
      if (this.operationMode === jsonConvertEnums.OperationMode.DISABLE) {
        return json;
      }
      if (json instanceof Array) {
        return this.deserializeArray(json, classReference);
      } else if (typeof json === "object") {
        return this.deserializeObject(json, classReference);
      } else {
        throw new Error("Fatal error in JsonConvert. Passed parameter json in JsonConvert.deserialize() is not in valid JSON format (object or array).\n");
      }
    };
    JsonConvert3.prototype.deserializeObject = function(jsonObject, classReference) {
      if (this.operationMode === jsonConvertEnums.OperationMode.DISABLE) {
        return jsonObject;
      }
      if (jsonObject === void 0) {
        throw new Error("Fatal error in JsonConvert. Passed parameter jsonObject in JsonConvert.deserializeObject() is undefined. This is not a valid JSON format.\n");
      } else if (jsonObject === null) {
        if (this.valueCheckingMode === jsonConvertEnums.ValueCheckingMode.DISALLOW_NULL) {
          throw new Error("Fatal error in JsonConvert. Passed parameter jsonObject in JsonConvert.deserializeObject() is undefined. You have specified to disallow null values.\n");
        } else {
          return jsonObject;
        }
      } else if (typeof jsonObject !== "object" || jsonObject instanceof Array) {
        throw new Error("Fatal error in JsonConvert. Passed parameter jsonObject in JsonConvert.deserializeObject() is not of type object.\n");
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
        console.log("----------");
        console.log("Receiving JSON object:");
        console.log(jsonObject);
      }
      var instance = new classReference();
      for (var _i = 0, _a = Object.keys(instance); _i < _a.length; _i++) {
        var propertyKey = _a[_i];
        try {
          this.deserializeObject_loopProperty(instance, propertyKey, jsonObject);
        } catch (ex) {
          if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
            console.log("Failed to deserialize property:");
            console.log(ex);
            console.log("----------");
          }
          throw ex;
        }
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
        console.log("Returning CLASS instance:");
        console.log(instance);
        console.log("----------");
      }
      return instance;
    };
    JsonConvert3.prototype.deserializeArray = function(jsonArray, classReference) {
      if (this.operationMode === jsonConvertEnums.OperationMode.DISABLE) {
        return jsonArray;
      }
      if (jsonArray === void 0) {
        throw new Error("Fatal error in JsonConvert. Passed parameter jsonArray in JsonConvert.deserializeObject() is undefined. This is not a valid JSON format.\n");
      } else if (jsonArray === null) {
        if (this.valueCheckingMode === jsonConvertEnums.ValueCheckingMode.DISALLOW_NULL) {
          throw new Error("Fatal error in JsonConvert. Passed parameter jsonArray in JsonConvert.deserializeObject() is undefined. You have specified to disallow null values.\n");
        } else {
          return jsonArray;
        }
      } else if (typeof jsonArray !== "object" || jsonArray instanceof Array === false) {
        throw new Error("Fatal error in JsonConvert. Passed parameter jsonArray in JsonConvert.deserializeArray() is not of type array.\n");
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.DISABLE) {
        return jsonArray;
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
        console.log("----------");
        console.log("Receiving JSON array:");
        console.log(jsonArray);
      }
      var array = [];
      for (var _i = 0, jsonArray_1 = jsonArray; _i < jsonArray_1.length; _i++) {
        var jsonObject = jsonArray_1[_i];
        array.push(this.deserializeObject(jsonObject, classReference));
      }
      if (this.operationMode === jsonConvertEnums.OperationMode.LOGGING) {
        console.log("Returning array of CLASS instances:");
        console.log(array);
        console.log("----------");
      }
      return array;
    };
    JsonConvert3.prototype.serializeObject_loopProperty = function(dataObject, instance, classPropertyName, json) {
      var mappingOptions = this.getClassPropertyMappingOptions(instance, classPropertyName);
      if (mappingOptions === null) {
        return;
      }
      var jsonPropertyName = mappingOptions.jsonPropertyName;
      var expectedJsonType = mappingOptions.expectedJsonType;
      var isOptional = mappingOptions.isOptional;
      var customConverter = mappingOptions.customConverter;
      var classInstancePropertyValue = dataObject[classPropertyName];
      if (typeof classInstancePropertyValue === "undefined") {
        if (isOptional || this._ignoreRequiredCheck)
          return;
        throw new Error('Fatal error in JsonConvert. Failed to map the JavaScript instance of class "' + instance[jsonConvertOptions.Settings.CLASS_IDENTIFIER] + '" to JSON because the defined class property "' + classPropertyName + '" does not exist or is not defined:\n\n	Class property: \n		' + classPropertyName + "\n\n	JSON property: \n		" + jsonPropertyName + "\n\n");
      }
      if (isOptional && classInstancePropertyValue === null)
        return;
      try {
        json[jsonPropertyName] = customConverter !== null ? customConverter.serialize(classInstancePropertyValue) : this.verifyProperty(expectedJsonType, classInstancePropertyValue, true);
      } catch (e) {
        throw new Error('Fatal error in JsonConvert. Failed to map the JavaScript instance of class "' + instance[jsonConvertOptions.Settings.CLASS_IDENTIFIER] + '" to JSON because of a type error.\n\n	Class property: \n		' + classPropertyName + "\n\n	Class property value: \n		" + classInstancePropertyValue + "\n\n	Expected type: \n		" + this.getExpectedType(expectedJsonType) + "\n\n	Runtime type: \n		" + this.getTrueType(classInstancePropertyValue) + "\n\n	JSON property: \n		" + jsonPropertyName + "\n\n" + e.message + "\n");
      }
    };
    JsonConvert3.prototype.deserializeObject_loopProperty = function(instance, classPropertyName, json) {
      var mappingOptions = this.getClassPropertyMappingOptions(instance, classPropertyName);
      if (mappingOptions === null) {
        return;
      }
      var jsonPropertyName = mappingOptions.jsonPropertyName;
      var expectedJsonType = mappingOptions.expectedJsonType;
      var isOptional = mappingOptions.isOptional;
      var customConverter = mappingOptions.customConverter;
      var jsonValue = void 0;
      try {
        jsonValue = this.getObjectValue(json, jsonPropertyName);
      } catch (_a) {
      }
      if (typeof jsonValue === "undefined") {
        if (isOptional || this._ignoreRequiredCheck)
          return;
        throw new Error('Fatal error in JsonConvert. Failed to map the JSON object to the class "' + instance[jsonConvertOptions.Settings.CLASS_IDENTIFIER] + '" because the defined JSON property "' + jsonPropertyName + '" does not exist:\n\n	Class property: \n		' + classPropertyName + "\n\n	JSON property: \n		" + jsonPropertyName + "\n\n");
      }
      if (isOptional && jsonValue === null)
        return;
      try {
        instance[classPropertyName] = customConverter !== null ? customConverter.deserialize(jsonValue) : this.verifyProperty(expectedJsonType, jsonValue);
      } catch (e) {
        throw new Error('Fatal error in JsonConvert. Failed to map the JSON object to the class "' + instance[jsonConvertOptions.Settings.CLASS_IDENTIFIER] + '" because of a type error.\n\n	Class property: \n		' + classPropertyName + "\n\n	Expected type: \n		" + this.getExpectedType(expectedJsonType) + "\n\n	JSON property: \n		" + jsonPropertyName + "\n\n	JSON type: \n		" + this.getJsonType(jsonValue) + "\n\n	JSON value: \n		" + JSON.stringify(jsonValue) + "\n\n" + e.message + "\n");
      }
    };
    JsonConvert3.prototype.getClassPropertyMappingOptions = function(instance, propertyName) {
      var mappings = instance[jsonConvertOptions.Settings.MAPPING_PROPERTY];
      if (typeof mappings === "undefined")
        return null;
      var prototype = Object.getPrototypeOf(instance);
      while (prototype !== null && prototype !== void 0) {
        var classIdentifier = prototype[jsonConvertOptions.Settings.CLASS_IDENTIFIER];
        if (!!classIdentifier) {
          var mappingName = classIdentifier + "." + propertyName;
          if (typeof mappings[mappingName] !== "undefined") {
            return mappings[mappingName];
          }
        }
        prototype = Object.getPrototypeOf(prototype);
      }
      return null;
    };
    JsonConvert3.prototype.verifyProperty = function(expectedJsonType, value, serialize) {
      if (expectedJsonType === any.Any || expectedJsonType === null || expectedJsonType === Object) {
        return value;
      }
      if (expectedJsonType instanceof Array === false && value instanceof Array === false) {
        if (typeof expectedJsonType !== "undefined" && expectedJsonType.prototype.hasOwnProperty(jsonConvertOptions.Settings.CLASS_IDENTIFIER)) {
          if (value === null) {
            if (this.valueCheckingMode !== jsonConvertEnums.ValueCheckingMode.DISALLOW_NULL)
              return null;
            else
              throw new Error("	Reason: Given value is null.");
          }
          if (serialize)
            return this.serializeObject(value, expectedJsonType);
          else
            return this.deserializeObject(value, expectedJsonType);
        } else if (expectedJsonType === any.Any || expectedJsonType === null || expectedJsonType === Object) {
          if (value === null) {
            if (this.valueCheckingMode !== jsonConvertEnums.ValueCheckingMode.DISALLOW_NULL)
              return null;
            else
              throw new Error("	Reason: Given value is null.");
          }
          return value;
        } else if (expectedJsonType === String || expectedJsonType === Number || expectedJsonType === Boolean) {
          if (value === null) {
            if (this.valueCheckingMode === jsonConvertEnums.ValueCheckingMode.ALLOW_NULL)
              return null;
            else
              throw new Error("	Reason: Given value is null.");
          }
          if (expectedJsonType === String && typeof value === "string" || expectedJsonType === Number && typeof value === "number" || expectedJsonType === Boolean && typeof value === "boolean") {
            return value;
          } else {
            if (this.ignorePrimitiveChecks)
              return value;
            throw new Error("	Reason: Given object does not match the expected primitive type.");
          }
        } else {
          throw new Error("	Reason: Expected type is unknown. There might be multiple reasons for this:\n	- You are missing the decorator @JsonObject (for object mapping)\n	- You are missing the decorator @JsonConverter (for custom mapping) before your class definition\n	- Your given class is undefined in the decorator because of circular dependencies");
        }
      }
      if (expectedJsonType instanceof Array && value instanceof Array) {
        var array = [];
        if (value.length === 0) {
          return array;
        }
        if (expectedJsonType.length === 0) {
          return value;
        }
        var autofillType = expectedJsonType.length < value.length;
        for (var i = 0; i < value.length; i++) {
          if (autofillType && i >= expectedJsonType.length)
            expectedJsonType[i] = expectedJsonType[i - 1];
          array[i] = this.verifyProperty(expectedJsonType[i], value[i], serialize);
        }
        return array;
      }
      if (expectedJsonType instanceof Array && value instanceof Object) {
        var array = [];
        if (value.length === 0) {
          return array;
        }
        if (expectedJsonType.length === 0) {
          return value;
        }
        var autofillType = expectedJsonType.length < Object.keys(value).length;
        var i = 0;
        for (var key in value) {
          if (autofillType && i >= expectedJsonType.length)
            expectedJsonType[i] = expectedJsonType[i - 1];
          array[key] = this.verifyProperty(expectedJsonType[i], value[key]);
          i++;
        }
        return array;
      }
      if (expectedJsonType instanceof Array) {
        if (value === null) {
          if (this.valueCheckingMode !== jsonConvertEnums.ValueCheckingMode.DISALLOW_NULL)
            return null;
          else
            throw new Error("	Reason: Given value is null.");
        }
        throw new Error("	Reason: Expected type is array, but given value is non-array.");
      }
      if (value instanceof Array) {
        throw new Error("	Reason: Given value is array, but expected a non-array type.");
      }
      throw new Error("	Reason: Mapping failed because of an unknown error.");
    };
    JsonConvert3.prototype.getObjectValue = function(data, key) {
      if (this.propertyMatchingRule === jsonConvertEnums.PropertyMatchingRule.CASE_INSENSITIVE) {
        var keyMapping = Object.keys(data).reduce(function(keys, key2) {
          keys[key2.toLowerCase()] = key2;
          return keys;
        }, {});
        key = keyMapping[key.toLowerCase()];
      }
      if (key in data === false) {
        throw new Error();
      }
      return data[key];
    };
    JsonConvert3.prototype.getExpectedType = function(expectedJsonType) {
      var type = "";
      if (expectedJsonType instanceof Array) {
        type = "[";
        for (var i = 0; i < expectedJsonType.length; i++) {
          if (i > 0)
            type += ",";
          type += this.getExpectedType(expectedJsonType[i]);
        }
        type += "]";
        return type;
      } else {
        if (expectedJsonType === any.Any || expectedJsonType === null || expectedJsonType === Object) {
          return "any";
        } else if (expectedJsonType === String || expectedJsonType === Boolean || expectedJsonType === Number) {
          return new expectedJsonType().constructor.name.toLowerCase();
        } else if (typeof expectedJsonType === "function") {
          return new expectedJsonType().constructor.name;
        } else if (expectedJsonType === void 0) {
          return "undefined";
        } else {
          return "?????";
        }
      }
    };
    JsonConvert3.prototype.getJsonType = function(jsonValue) {
      if (jsonValue === null)
        return "null";
      var type = "";
      if (jsonValue instanceof Array) {
        type = "[";
        for (var i = 0; i < jsonValue.length; i++) {
          if (i > 0)
            type += ",";
          type += this.getJsonType(jsonValue[i]);
        }
        type += "]";
        return type;
      } else {
        return typeof jsonValue;
      }
    };
    JsonConvert3.prototype.getTrueType = function(trueValue) {
      return typeof trueValue;
    };
    return JsonConvert3;
  }();
  exports.JsonConvert = JsonConvert2;
});
var jsonConvertDecorators = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  function JsonConverter2(target) {
    target[jsonConvertOptions.Settings.MAPPER_PROPERTY] = "";
  }
  exports.JsonConverter = JsonConverter2;
  function JsonObject2(target) {
    var classIdentifier = "";
    var decorator = function(target2) {
      target2.prototype[jsonConvertOptions.Settings.CLASS_IDENTIFIER] = classIdentifier.length > 0 ? classIdentifier : target2.name;
      var mapping = target2.prototype[jsonConvertOptions.Settings.MAPPING_PROPERTY];
      if (!mapping)
        return;
      var unmappedKeys = Object.keys(mapping).filter(function(val) {
        return val.indexOf(jsonConvertOptions.Settings.CLASS_IDENTIFIER + ".") === 0;
      });
      for (var _i = 0, unmappedKeys_1 = unmappedKeys; _i < unmappedKeys_1.length; _i++) {
        var key = unmappedKeys_1[_i];
        mapping[key.replace(jsonConvertOptions.Settings.CLASS_IDENTIFIER, target2.prototype[jsonConvertOptions.Settings.CLASS_IDENTIFIER])] = mapping[key];
        delete mapping[key];
      }
    };
    var type = typeof target;
    switch (type) {
      case "string":
        classIdentifier = target;
        return decorator;
      case "function":
      case "undefined":
      default:
        throw new Error("Fatal error in JsonConvert. It is mandatory to pass a string as parameter in the @JsonObject decorator.\n\nUse @JsonObject(classId) where classId is a string.\n\n");
    }
  }
  exports.JsonObject = JsonObject2;
  function JsonProperty2() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      params[_i] = arguments[_i];
    }
    return function(target, classPropertyName) {
      var jsonPropertyName = classPropertyName;
      var conversionOption = any.Any;
      var isOptional = false;
      switch (params.length) {
        case 1:
          if (params[0] === void 0)
            throw new Error('Fatal error in JsonConvert. It is not allowed to explicitly pass "undefined" as first parameter in the @JsonProperty decorator.\n\n	Class property: \n		' + classPropertyName + "\n\nLeave the decorator parameters empty if you do not wish to pass the first parameter.\n\n");
          jsonPropertyName = params[0];
          break;
        case 2:
          if (params[0] === void 0)
            throw new Error('Fatal error in JsonConvert. It is not allowed to explicitly pass "undefined" as first parameter in the @JsonProperty decorator.\n\n	Class property: \n		' + classPropertyName + "\n\nLeave the decorator parameters empty if you do not wish to pass the first parameter.\n\n");
          if (params[1] === void 0)
            throw new Error('Fatal error in JsonConvert. It is not allowed to explicitly pass "undefined" as second parameter in the @JsonProperty decorator.\n\n	Class property: \n		' + classPropertyName + '\n\nUse "Any" to allow any type. You can import this class from "json2typescript".\n\n');
          jsonPropertyName = params[0];
          conversionOption = params[1];
          break;
        case 3:
          if (params[0] === void 0)
            throw new Error('Fatal error in JsonConvert. It is not allowed to explicitly pass "undefined" as first parameter in the @JsonProperty decorator.\n\n	Class property: \n		' + classPropertyName + "\n\nLeave the decorator parameters empty if you do not wish to pass the first parameter.\n\n");
          if (params[1] === void 0)
            throw new Error('Fatal error in JsonConvert. It is not allowed to explicitly pass "undefined" as second parameter in the @JsonProperty decorator.\n\n	Class property: \n		' + classPropertyName + '\n\nUse "Any" to allow any type. You can import this class from "json2typescript".\n\n');
          jsonPropertyName = params[0];
          conversionOption = params[1];
          isOptional = params[2];
          break;
      }
      if (typeof target[jsonConvertOptions.Settings.MAPPING_PROPERTY] === "undefined") {
        target[jsonConvertOptions.Settings.MAPPING_PROPERTY] = [];
      }
      var jsonPropertyMappingOptions = new jsonConvertOptions.MappingOptions();
      jsonPropertyMappingOptions.classPropertyName = classPropertyName;
      jsonPropertyMappingOptions.jsonPropertyName = jsonPropertyName;
      jsonPropertyMappingOptions.isOptional = isOptional ? isOptional : false;
      if (typeof conversionOption !== "undefined" && conversionOption !== null && typeof conversionOption[jsonConvertOptions.Settings.MAPPER_PROPERTY] !== "undefined") {
        jsonPropertyMappingOptions.customConverter = new conversionOption();
      } else {
        jsonPropertyMappingOptions.expectedJsonType = conversionOption;
      }
      if (typeof target[jsonConvertOptions.Settings.MAPPING_PROPERTY][jsonConvertOptions.Settings.CLASS_IDENTIFIER + "." + classPropertyName] === "undefined") {
        target[jsonConvertOptions.Settings.MAPPING_PROPERTY][jsonConvertOptions.Settings.CLASS_IDENTIFIER + "." + classPropertyName] = jsonPropertyMappingOptions;
      } else {
        throw new Error("Fatal error in JsonConvert. It is not allowed to add multiple decorators for the same property.\n\n	Class property: \n		" + classPropertyName + "\n\n");
      }
    };
  }
  exports.JsonProperty = JsonProperty2;
});
var json2typescript = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.JsonConvert = jsonConvert.JsonConvert;
  exports.ValueCheckingMode = jsonConvertEnums.ValueCheckingMode;
  exports.OperationMode = jsonConvertEnums.OperationMode;
  exports.JsonObject = jsonConvertDecorators.JsonObject;
  exports.JsonProperty = jsonConvertDecorators.JsonProperty;
  exports.JsonConverter = jsonConvertDecorators.JsonConverter;
  exports.Any = any.Any;
});
var JsonConvert = json2typescript.JsonConvert;
var JsonConverter = json2typescript.JsonConverter;
var JsonObject = json2typescript.JsonObject;
var JsonProperty = json2typescript.JsonProperty;
export {JsonConvert, JsonConverter, JsonObject, JsonProperty};
